class ProductCard extends HTMLElement {
  constructor() {
    super();
    this.allVariants = this.querySelectorAll(
      ".solstice__product-card-variants ul li"
    );
    this.selectedVariant = this.querySelector(
      ".solstice__product-card-variants ul li.selected"
    );
    this.allVariants.forEach((variantImage) => {
      variantImage.addEventListener("click", () => {
        this.allVariants.forEach((variant) => {
          variant.classList.remove("selected");
        });

        this.selectedVariant = variantImage;
        this.selectedVariant.classList.add("selected");
        this.querySelector(".solstice__product-card-image img").setAttribute(
          "src",
          this.selectedVariant.dataset.image
        );
        this.querySelector(".solstice__product-card-image a").setAttribute(
          "href",
          this.selectedVariant.dataset.variantUrl
        );
      });
    });
  }
}
if (!customElements.get("product-card")) {
  customElements.define("product-card", ProductCard);
}
